import React, { FC, useState }     from 'react';
import { CorvalUIColor }           from '../../../../../types';
import { HelpAndSupportStatement } from '../../../../components/util/messaging/HelpAndSupportStatement';
import { StyledContainer }         from '../../../../containers';

interface Props {}

const defaultProps: Props = {}

const EmptyProjectList: FC<Props> = ( props ) => {

	return (

		<StyledContainer as={ 'div' }>
			<p>You don't have any active projects under this organization.</p>
			<p>
				Please contact your
				{ ' ' }
				<HelpAndSupportStatement
					withInlineCasing={ true }
					withPreAmble={ false }
					contactName={ 'customer success representative' }
					withPostAmble={ false }
				/>
				{ ' ' }
				to set one up.
			</p>
		</StyledContainer>
	);
};

EmptyProjectList.defaultProps = defaultProps;

export { EmptyProjectList }
